import { render, staticRenderFns } from "./SubButtons.vue?vue&type=template&id=6cdcfe0d&"
import script from "./SubButtons.vue?vue&type=script&lang=js&"
export * from "./SubButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports